import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IWindowSnare } from '../models/interfaces/i-window-snare.interface';
import { WINDOW } from '../shared-providers/window.providers';

@Injectable({
    providedIn: 'root'
})
export class HostInterceptor implements HttpInterceptor {
    baseUrl: string;

    private url = [
        'budgetapi',
        'creditreportingapi',
        'notificationsapi',
        'notificationsapi2',
        'pfmapi',
        'corepfmapi',
        'desktopunderwriterapi',
        'verificationapi',
        'fda-consumer',
        'signalr',
        'questionnaireapi',
        'fda-webhook',
        'argyle-consumer',
        'events-consumer',
        'theme-consumer',
        'property',
        'readinessapi',
        'mobileapi',
        'articleapi',
        'addressapi',
        'datasharing-consumer',
        'financialinsights',
        'objectivesapi',
        'stepbystepguideapi',
        'buyervision-consumer',
        'flidentityapi-consumer',
        'genai-consumer',
        'localization'
    ];

    constructor(@Inject(WINDOW) private window: IWindowSnare) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Support for vanity URLs. Vanity URLs will be either the form
        // of customervanityname.customername.tld or customername.finlocker.com

        if (environment.enableApiGateway) {
            // split into something like ["portal", "stage", "finlocker", "com"]
            const splitHost = this.window.location.host.split('.');
            const splitUrl = request.url.split('/');
            const isApiCall = splitUrl[1] && this.url.some(x => x === splitUrl[1].toLocaleLowerCase());
            // eslint-disable-next-line

            if (isApiCall) {
                if (environment.production) {
                    const isDev = splitHost.some(x => x === 'devg3' || x === 'dev');
                    const isStage = splitHost.some(x => x === 'stage' || x === 'stageg3');

                    if (isDev) {
                        this.baseUrl = `${this.window.location.protocol}//flapi.devg3.finlocker.com`;
                    } else if (isStage) {
                        this.baseUrl = `${this.window.location.protocol}//flapi.stage.finlocker.com`;
                    } else {
                        this.baseUrl = `${this.window.location.protocol}//flapi.finlocker.com`;
                    }
                } else {
                    this.baseUrl = this.window.location.protocol + '//' + this.window.location.host + '/flapi';
                }

                request = request.clone({
                    url: this.baseUrl + request.url
                });
            }
        }

        return next.handle(request);
    }
}
